<template>
  <section class="all-cases-view" v-loading="loading">
    <div class="hospitals-branches-list">
      <div class="listings-navbar">
        <el-row>
          <el-col :lg="24">
            <ul
              class="d-flex flex-wrap justify-content-end list-items-group-15 mb-10"
            >
              <li v-if="hasPermission('hospitals', 'add')">
                <el-button class="btn button-with-icon" @click="goToNewBranch">
                  <span class="mr-8">
                    <img
                      src="@/assets/images/icons/plus-icon.svg"
                      alt="icon"
                      class="inactive"
                    />
                    <img
                      src="@/assets/images/icons/plus-icon-white.svg"
                      alt="icon"
                      class="active"
                    />
                  </span>
                  <span> ADD NEW BRANCH</span>
                </el-button>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>

      <div class="primary-content-view-new">
        <div class="listings listings__table listings__all-cases">
          <el-table :data="getAllBranches.data">
            <el-table-column label="Location" width="320">
              <template v-slot="scope">{{
                scope.row.ordering_location || "-"
              }}</template>
            </el-table-column>

            <el-table-column label="Display Name" width="320">
              <template v-slot="scope">{{ scope.row.display_name }}</template>
            </el-table-column>

            <el-table-column label="Code" width="320">
              <template v-slot="scope">{{ scope.row.location_code }}</template>
            </el-table-column>
            <el-table-column label="Address" max-width="340">
              <template v-slot="scope">
                <span class="text-center">{{ scope.row.address }}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="action"
              label="Action"
              fixed="right"
              width="80"
            >
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li v-if="hasPermission('hospitals', 'add')">
                    <el-button
                      class="view-button"
                      title="Edit Branch"
                      @click="onView(scope.row)"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/edit-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/edit-deactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[20, 25, 50, 100]"
            layout=" prev, pager, next, jumper, sizes ,total"
            :total="getAllBranches.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <el-dialog v-model="addNewBranchDialog" :destroy-on-close="true">
      <AddBranch></AddBranch>
    </el-dialog>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { defineAsyncComponent } from "vue";
const AddBranch = defineAsyncComponent(() =>
  import("@/components/hospitals/branches/AddBranch")
);
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      addNewBranchDialog: false,
      page: 1,
      loading: false,
      pageSize: 10,
      orderBy: "",
      orderType: "",
      pageSizes: [10, 15, 20],
    };
  },
  mixins: [UserPermissionsHelper],
  components: {
    AddBranch,
  },
  computed: {
    ...mapGetters("branches", ["getAllBranches", "getBranchDeleteStatus"]),
    hospital_id() {
      if (this.$route.params.hospital_id) {
        return this.$route.params.hospital_id;
      }
      return null;
    },
  },
  async mounted() {
    await this.fetchBranchesList(this.page);
  },
  methods: {
    async fetchBranchesList(page) {
      this.page = page;
      this.loading = true;

      let params = {
        page: this.page,
        limit: this.pageSize,
        hospital_id: this.hospital_id,
        order_by: this.orderBy || "updated_at",
        order_type: this.orderType || "desc",
      };
      await this.$store.dispatch("branches/fetchAllBranches", params);
      this.loading = false;
    },
    onView(branchInfo) {
      this.$router.push({
        name: "Edit-Branch",
        params: { location_id: branchInfo._id, hospital_id: this.hospital_id },
        query: this.$route.query,
      });
    },

    goToNewBranch() {
      this.$router.push({ name: "Add-Branch" });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchBranchesList();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchBranchesList();
    },
    async onDelete(id) {
      this.$confirm("Are you sure to delete Branch?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.deleteBranch(id);
      });
    },
    async deleteBranch(id) {
      let params = {
        hospital_id: this.hospital_id,
        location_id: id,
      };
      await this.$store.dispatch("branches/deleteBranch", params);
      if (this.getBranchDeleteStatus) {
        successNotification("Branch deleted successfully");
        this.loading = true;
        await this.fetchBranchesList(this.page);
        this.loading = false;
      } else {
        errorNotification(
          this.getBranchDeleteError || "Error while deleting Branch"
        );
      }
    },
  },
};
</script>
